import * as CubeTree from '../../../cubeTree/index';
import Select from '../../select/index';

function moveShelfSelect(beAddedCube: CubeNode, task: InsertInfo): void {
    if (CubeTree.isShelf(task.targetId)) {
        let removeSelectCubes: Array<CubeId> = CubeTree.findAllChildren(task.targetId);

        removeSelectCubes.push(task.targetId);

        // 把货架选中状态移除，把其子级的选中状态也移除
        Select.removeGroup(removeSelectCubes);

        // 选中当前新增的货架
        Select.addOne(beAddedCube.id);

        return;
    }

    let cubeInStage: Array<CubeId> = CubeTree.findCubeInStage();

    Select.removeGroup(cubeInStage);

    // 选中当前新增的货架
    Select.addOne(beAddedCube.id);
}

export {
    moveShelfSelect
};
